// extracted by mini-css-extract-plugin
export default {"activityFeed__title":"styles_activity-feed__title__uOS2l"};